<template>
  <modal-default
      ref="modal"
      title="Attach Contact"
      :width="500"
      :short-circuit-close="true"
      @close="cancel"
      is-double-column
  >
    <add-contact-to-record-form ref="addContactForm" @changeIsExistingContact="isExistingContact = $event"></add-contact-to-record-form>

    <template v-slot:footer>
      <button-default
          v-if="isExistingContact"
          @click="saveContact"
          :loading="isSaving"
      >Attach Contact</button-default>

      <button-default
        v-else
        @click="saveContact"
        :loading="isSaving"
      >Create & Attach Contact</button-default>
    </template>
  </modal-default>
</template>

<script>
import ModalBase from "../../../components/modal/ModalBase";
import {destroyModal} from "../../../services/modals";
import AddContactToRecordForm from "../../../forms/AddContactToRecordForm";
import dates from "../../../services/dates";

export default {
  name: "AttachContactToLeadModal",
  components: {AddContactToRecordForm, ModalBase},
  props: {
    record: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      date: dates.getNowISO(),
      isExistingContact: true,
      isSaving: false,
    }
  },
  mounted() {
    this.$refs.modal.open();
  },
  methods: {
    confirmed() {
      this.$emit('confirmed', this.date);
      destroyModal(this.$refs.modal);
    },
    cancel() {
      this.$emit('canceled');
      destroyModal(this.$refs.modal);
    },
    saveContact() {
      this.isSaving = true;
      return this.$refs.addContactForm.save()
        .then(() => {
          destroyModal(this.$refs.modal)
        })
        .finally(() => { this.isSaving = false })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
